/* eslint-disable no-unused-vars */
import DokanListIcons from '../../components/icon/DokanListIcons';

function WithdrawAlert({ show = false, message = '', onClose }) {
    const handleClose = () => {
        onClose();
    };
    return (
        <>
            {show && (
                <div className="withdraw-alert withdraw-alert-success flex justify-between items-center">
                    <div className="withdraw-alert-text">{message}</div>
                    <button
                        type="button"
                        className="py-2 px-1 focus:outline-none"
                        onClick={handleClose}
                    >
                        <DokanListIcons icon="alert_success_dismiss" size={14} />
                    </button>
                </div>
            )}
        </>
    );
}

export default WithdrawAlert;
